import { Phone, ArrowRight } from "lucide-react";

const PHONE_NUMBER = "(866) 567-7867";
const PHONE_HREF = "tel:+18665677867";

export const EmergencyBanner = () => (
  <div className="bg-accent text-white text-center py-1.5 px-4 text-[12px] font-medium tracking-wide">
    <a href={PHONE_HREF} className="inline-flex items-center gap-1.5 hover:opacity-90 transition-opacity">
      <Phone className="w-3 h-3" />
      <span className="hidden sm:inline">Lost Water? Call Now for Same-Day Service</span>
      <span className="sm:hidden">Emergency? Call Now</span>
      <span className="font-bold underline underline-offset-2">{PHONE_NUMBER}</span>
    </a>
  </div>
);

export { PHONE_NUMBER, PHONE_HREF };
